import axiosInstance from '../../../../../services/axios/axios';
import { then } from '../../../../../services/axios/_utility';

/**
 * Asynchronously retrieves names of departments related to @param costCenter of user search
 *
 * @function
 * @param {string} costCenter cost center ID.
 * @returns {object[]} array of key-value-pairs of departments.
 */
export const getDepartmentNames = costCenter => {
	return axiosInstance
		.get(`api/Components/Dropdown/DEPARTMENTS?CostCenter=${costCenter}`)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};
